<template>
  <NavBar></NavBar>
  <div class="title">Art'OBER 2023 - Partie 1</div>
  <div class="subtitle">Jour 1 : <span>Mexique & Folklore étranger</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_THEO_D1.jpg" alt="test" />
      <figcaption>Artiste : blackrabbit974</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_NEBS_D1.png" alt="test" />
      <figcaption>Artiste : nebsu.</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_THMS_D1.jpg" alt="test" />
      <figcaption>Artiste : vamlack</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_LOSE_D1.jpg" alt="test" />
      <figcaption>Artiste : louise2585</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_ADRI_D1.jpg" alt="test" />
      <figcaption>Artiste : zeobuilder10</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_ANDR_D1.jpg" alt="test" />
      <figcaption>Artiste : assyah</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 2 : <span>Citrouille</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_SOPH_D2.jpg" alt="test" />
      <figcaption>Artiste : sosomi22</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_MATH_D2.jpg" alt="test" />
      <figcaption>Artiste : ___zombie___</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_AMAN_D2.jpg" alt="test" />
      <figcaption>Artiste : amandine3068</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SEA_D2.png" alt="test" />
      <figcaption>Artiste : s.e_a</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_KAIS_D2.jpg" alt="test" />
      <figcaption>Artiste : _kaishi_</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_PIER_D2.jpg" alt="test" />
      <figcaption>Artiste : duolinova</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 3 : <span>Sorcellerie</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_HCTR_D3.jpg" alt="test" />
      <figcaption>Artiste : relo.pataloo</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SAPH_D3.png" alt="test" />
      <figcaption>Artiste : saphir_8565</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_ADRI_D3.jpg" alt="test" />
      <figcaption>Artiste : zeobuilder10</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_PIER_D3.jpg" alt="test" />
      <figcaption>Artiste : duolinova</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_THMS_D3.jpg" alt="test" />
      <figcaption>Artiste : vamlack</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_KRME_D3.jpg" alt="test" />
      <figcaption>Artiste : ikrome</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 4 : <span>Temps</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_LIPS_D4.jpg" alt="test" />
      <figcaption>Artiste : lipsem1651</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_KAIS_D4.jpg" alt="test" />
      <figcaption>Artiste : _kaishi_</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_AMAN_D4.jpg" alt="test" />
      <figcaption>Artiste : amandine3068</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_MATH_D4.jpg" alt="test" />
      <figcaption>Artiste : ___zombie___</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_THEO_D4.jpg" alt="test" />
      <figcaption>Artiste : blackrabbit974</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_ADRI_D4.jpg" alt="test" />
      <figcaption>Artiste : zeobuilder10</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 5 : <span>Vampire</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_ALIN_D5.jpg" alt="test" />
      <figcaption>Artiste : __patate</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_LOUI_D5.jpg" alt="test" />
      <figcaption>Artiste : szlouis</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_NEBS_D5.jpg" alt="test" />
      <figcaption>Artiste : nebsu.</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SEA_D5.png" alt="test" />
      <figcaption>Artiste : s.e_a</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_PIER_D5.jpg" alt="test" />
      <figcaption>Artiste : duolinova</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_THEO_D5.jpg" alt="test" />
      <figcaption>Artiste : blackrabbit974</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 6 : <span>Esprits</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_PATA_D6.jpg" alt="test" />
      <figcaption>Artiste : _patatra</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_AMAN_D6.jpg" alt="test" />
      <figcaption>Artiste : amandine3068</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_HCTR_D6.jpg" alt="test" />
      <figcaption>Artiste : relo.pataloo</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_LOSE_D6.jpg" alt="test" />
      <figcaption>Artiste : louise2585</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_KRME_D6.jpg" alt="test" />
      <figcaption>Artiste : ikrome</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_LIPS_D6.jpg" alt="test" />
      <figcaption>Artiste : lipsem1651</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 7 : <span>Insectes</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_MORA_D7.jpg" alt="test" />
      <figcaption>Artiste : morangec</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_NEBS_D7.jpg" alt="test" />
      <figcaption>Artiste : nebsu.</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SOPH_D7.jpg" alt="test" />
      <figcaption>Artiste : sosomi22</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_AMAN_D7.jpg" alt="test" />
      <figcaption>Artiste : amandine3068</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_CLEM_D7.webp" alt="test" />
      <figcaption>Artiste : chelseannamonroll</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_ADRI_D7.jpg" alt="test" />
      <figcaption>Artiste : zeobuilder10</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 8 : <span>Cinéma</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_SAPH_D8.png" alt="test" />
      <figcaption>Artiste : saphir_8565</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_MORA_D8.jpg" alt="test" />
      <figcaption>Artiste : morangec</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SOPH_D8.jpg" alt="test" />
      <figcaption>Artiste : sosomi22</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_PIER_D8.jpg" alt="test" />
      <figcaption>Artiste : duolinova</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_HCTR_D8.jpg" alt="test" />
      <figcaption>Artiste : relo.pataloo</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_YASS_D8.jpg" alt="test" />
      <figcaption>Artiste : yassten</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 9 : <span>Sanguin</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_SAPH_D9.png" alt="test" />
      <figcaption>Artiste : saphir_8565</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_LOUI_D9.png" alt="test" />
      <figcaption>Artiste : szlouis</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SEA_D9.png" alt="test" />
      <figcaption>Artiste : s.e_a</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_THEO_D9.jpg" alt="test" />
      <figcaption>Artiste : blackrabbit974</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_LIPS_D9.jpg" alt="test" />
      <figcaption>Artiste : lipsem1651</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_PIER_D9.jpg" alt="test" />
      <figcaption>Artiste : duolinova</figcaption>
    </figure>
  </div>
  <div class="subtitle">Jour 10 : <span>Monstre</span></div>
  <div id="columns">
    <figure>
      <img src="./images_albums/artober2023/ART2023_TELU_D10.jpg" alt="test" />
      <figcaption>Artiste : telulum</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_PATA_D10.gif" alt="test" />
      <figcaption>Artiste : _patatra</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_MARI_D10.png" alt="test" />
      <figcaption>Artiste : nextsmile</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_SEA_D10.png" alt="test" />
      <figcaption>Artiste : s.e_a</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_ADRI_D10.jpg" alt="test" />
      <figcaption>Artiste : zeobuilder10</figcaption>
    </figure>
    <figure>
      <img src="./images_albums/artober2023/ART2023_KAIS_D10.jpg" alt="test" />
      <figcaption>Artiste : _kaishi_</figcaption>
    </figure>
  </div>
  <FooTer></FooTer>
</template>
        
    <script>
import NavBar from "@/components/NavBar.vue";
import FooTer from "@/components/FooTer.vue";

export default {
  components: {
    NavBar,
    FooTer,
  },
  data() {
    return {
      showMobileMenu: false,
    };
  },
  methods: {
    showMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    showSettings() {
      // Handle the settings click event here
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "BebasNeue";
  src: url("@/assets/BebasNeue-Regular.woff2") format("woff2"),
    url("@/assets/BebasNeue-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Amarillo";
  src: url("@/assets/Amarillo.ttf") format("truetype");
}

@font-face {
  font-family: "Calluna";
  src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/4273/callunasansregular-webfont.woff")
    format("woff");
}

.title {
  font-family: "BebasNeue", sans-serif;
  margin-top: 250px;
  font-size: 50px;
  text-align: center;
  margin-bottom: -200px;
  span {
    background-color: #fef200;
  }
}

.subtitle {
  font-family: "BebasNeue", sans-serif;
  margin-top: 250px;
  font-size: 30px;
  text-align: center;
  margin-bottom: -200px;
  span {
    background-color: #fef200;
  }
}

body {
  background: url(//subtlepatterns.com/patterns/scribble_light.png);
  min-height: 1000px;
  left: 0;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0;
}

.search-container {
  margin-top: 250px;
  display: flex;
  align-items: center;
  justify-content: center; /* Centrer horizontalement */
  margin-bottom: -100px;
}

input[type="text"] {
  padding: 7.5px;
  border: 1px solid #ccc;
  border-radius: 5px 0 0 5px;
  font-size: 20px;
}

button {
  padding: 8.5px 20px;
  background-color: #00adef;
  color: white;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 20px;
}

button:hover {
  background-color: #00adef;
}

input[type="text"]:focus {
  outline: none;
  border-color: #00adef;
}

#columns {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
  max-width: 1100px;
  margin: 50px auto;
  margin-top: 200px;
  left: 0;
  margin-bottom: -200px;
}

div#columns figure {
  position: relative; /* Définir la position relative pour le conteneur */
  width: calc(29%); /* Largeur de chaque figure (33.33% - marge) */
  margin-bottom: 20px; /* Espacement entre les lignes */
  background: #fefefe;
  border: 2px solid #fcfcfc;
  box-shadow: 0 5px 20px rgba(1, 1, 1, 0.2);
  margin: 50px 2px 15px;
  padding: 15px;
  padding-bottom: 10px;
  transition: opacity 0.4s ease-in-out;
  display: inline-block;
  border-radius: 10px;
  transition: 0.3s ease;
}

div#columns figure:hover {
  transform: scale(1.05);
}

div#columns figure img {
  width: 100%; /* Utiliser 100% de la largeur du conteneur */
  height: auto; /* Hauteur automatique pour conserver les proportions */
  max-width: 100%; /* Pour s'assurer que l'image ne dépasse pas la largeur spécifiée */
  padding-bottom: 15px;
  margin-bottom: 5px;
}

div#columns figure figcaption {
  position: absolute; /* Position absolue par rapport au conteneur parent */
  bottom: 0; /* Coller en bas */
  right: 0; /* Coller à droite */
  font-size: 15px;
  color: #000000;
  line-height: 1.5;
  font-family: "BebasNeue", sans-serif;
  padding: 2px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: right;
}

div#columns figure figcaption:hover {
  text-decoration: underline;
  cursor: pointer;
}

div#columns figure p {
  font-size: 18px;
  color: #000000;
  line-height: 1.5;
  font-family: "BebasNeue", sans-serif;
  padding: 2px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: left;
  font-family: "BebasNeue", sans-serif;
}

div#columns small {
  font-size: 1rem;
  float: right;
  text-transform: uppercase;
  color: #000000;
}

div#columns small a {
  color: #000000;
  text-decoration: none;
  transition: 0.4s color;
}

@media screen and (max-width: 1600px) {
  #columns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column; /* Mettre les conteneurs en colonne */
    justify-content: center; /* Centrer verticalement les conteneurs */
    align-items: center; /* Centrer horizontalement les conteneurs */
  }
  #columns figure {
    width: calc(70%) !important;
  }
}
</style>